import { Header } from '@pentabd/ui';
import { t } from 'i18next';
import { DownloadCsvButtons } from './DownloadCsvButtons';

export const CenterWiseReport = () => {
  return (
    <div className="mt-20">
      <Header
        headerText={{ header: t('CONSTITUENCY_WISE_RESULTS.HEADER.REPORT') }}
      />
      <DownloadCsvButtons />
    </div>
  );
};
